module.exports = __webpack_public_path__ + "static/img/default.70131748.png";